import PropTypes from 'prop-types';
import React from "react";

class FederatedInstructions extends React.Component {

    render() {

        const { query, results } = this.props;
        const { numFound } = results;

        if (numFound > 0) {
            return ("")
        }

        return (
          <div className="search-no-results-text">
            <p>
              No results were found for your search. Try again by changing your
              search terms or checking the spelling of your search terms.
            </p>
          </div>
        );
    }
}

FederatedInstructions.propTypes = {
    query: PropTypes.object,
    results: PropTypes.object
}

export default FederatedInstructions;
